export const vidrisSequential: string[] = [];
export const vidrisSequentialMixed: string[] = [];
